// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bottom-actions {
  padding: 12px 0 0 12px;
  position: absolute;
  right: 10px;
  bottom: 40px;
  max-height: 90vh;
  overflow-y: auto;
}

  .bottom-actions__container {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 12px;
  }
`, "",{"version":3,"sources":["webpack://./src/routes/pages/MapWidget/common/BottomActions/style.scss"],"names":[],"mappings":"AAEA;EACE,sBAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAQlB;;EANE;IACE,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,SAAY;EACd","sourcesContent":["@import '../../../../../../assets/scss/variables.scss';\n\n.bottom-actions {\n  padding: $md-gap 0 0 $md-gap;\n  position: absolute;\n  right: 10px;\n  bottom: 40px;\n  max-height: 90vh;\n  overflow-y: auto;\n\n  &__container {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-end;\n    gap: $md-gap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
